import React, {useEffect, useState} from 'react';

import { HeartIcon, ClipboardCopyIcon, DocumentTextIcon } from '@heroicons/react/outline';

const OrganizationDailyStats = ({allMsgOrg, copiedOrg, likedOrg}) => {

    const [ dailyProjects, setDailyProjects ] = useState()
    const [ dailyCopied, setDailyCopied ] = useState() 
    const [ dailyLiked, setDailyLiked ] = useState() 

    var all = dailyProjects ? dailyProjects?.length : 0;
    var copied = (dailyProjects && dailyCopied) ? ((dailyCopied?.length / dailyProjects?.length)*100) : 0;
    var liked = (dailyProjects && dailyLiked) ? ((dailyLiked?.length / dailyProjects?.length)*100) :0;

    useEffect(() => {
        const DailyProjects = () => {
            var arr = [];
            var arrCopied = [];
            var arrLiked = [];
            allMsgOrg?.map(projects =>{
                if(projects.ContentCreated){
                    projects.ContentCreated.map(project => {
                        const date1 = new Date(project.CreatedAt.toDate())
                        const date2 = new Date();
                        const diffTime = Math.abs(date2 - date1);
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            
                        if(diffDays < 2){
                            arr.push(project)
                        }
                        return arr
                    })
                return projects
            }else { 
                return null
            }
            })
            copiedOrg?.map(project =>{
                if(project.createdAt){
                const date1 = new Date(project.createdAt.toDate())
                const date2 = new Date();
                const diffTime = Math.abs(date2 - date1);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
                
                //treba u staroj da se popravi(dodati novi contentCopy niz ili novu kolekciju) jer povlaci stari datum 
                if(diffDays < 2){
                    arrCopied.push(project)
                }
                return arrCopied
            }else { 
                return null
            }
            })
            likedOrg?.map(project =>{
                if(project.CreatedAt){
                const date1 = new Date(project.CreatedAt.toDate())
                const date2 = new Date();
                const diffTime = Math.abs(date2 - date1);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
                
                if(diffDays < 2){
                    arrLiked.push(project)
                }
                return arrLiked
            }else { 
                return null
            }
            })
            setDailyProjects(arr)
            setDailyCopied(arrCopied)
            setDailyLiked(arrLiked)
        }

       DailyProjects()
    }, [allMsgOrg, copiedOrg, likedOrg])

    const stats = [
        { name: 'Messages Created Today', stat:  all, icon: DocumentTextIcon, href: '/allDailyProjects'},
        { name: 'Copied Today', stat:  copied.toFixed(2) === 'NaN' ? (0 + ' %') : copied.toFixed(2) + ' %', icon: ClipboardCopyIcon, href: '/copiedDaily', length: dailyCopied?.length},
        { name: 'Fire Today', stat: liked.toFixed(2) === 'NaN' ? (0 + ' %') : liked.toFixed(2) + ' %', icon: HeartIcon, href: '/likedDaily', length: dailyLiked?.length},
    ]

    return (
        <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900 my-6">Team Daily Messages</h3>
            <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {stats.map((item) => (
                <div
                key={item.name}
                className="relative bg-white pt-5 px-4 pb-4 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden"
                >
                <dt>
                    <div className="absolute bg-yellow-500 rounded-md p-3">
                    <item.icon className="h-6 w-6 text-white" aria-hidden="true" />
                    </div>
                    <p className="ml-16 text-sm font-medium text-gray-500 truncate">{item.name}</p>
                </dt>
                <dd className="ml-16 flex items-baseline ">
                    <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
                </dd>
                {item.length > 0 ?
                <div className="font-medium text-gray-600 text-right my-2">
                    Amount: {item.length}
                </div>
                :
                null }
                </div>
            ))}
            </dl>
        </div>
    )
}

export default OrganizationDailyStats